// Orders

import OrdersPageCover from "components/covers/pages/OrdersPageCover";
import { MdNoteAlt, MdPending, MdMiscellaneousServices, MdAssignmentReturn } from "react-icons/md";

const ORDERS = {
	"/orders": {
		id: "/orders",
		title: "All Orders",
		type: "single",
		icon: MdNoteAlt,
		url: "/orders",
		pageCover: OrdersPageCover,
		disabled: false,
	},
	"/orders/service-requests": {
		id: "/orders/service-requests",
		title: "Service Requests",
		type: "single",
		icon: MdMiscellaneousServices,
		url: "/orders/service-requests",
		pageCover: OrdersPageCover,
		disabled: false,
	},
	"/orders/backordered": {
		id: "/orders/backordered",
		title: "Backordered",
		type: "single",
		icon: MdAssignmentReturn,
		url: "/orders/backordered",
		pageCover: OrdersPageCover,
		disabled: false,
	},
	"/orders/pending": {
		id: "/orders/pending",
		title: "Pending Orders",
		type: "single",
		icon: MdPending,
		url: "/orders/pending",
		disabled: true,
	},
};

export default ORDERS;
